module.exports = __webpack_public_path__ + "static/media/fresh-spoke.bd3c89ca.png";